import { TaskParams } from 'types/getParams';
import { TTask } from 'types/task';

import { CRMAPIBase } from '@api/crmApiBase';
import { RequestResult } from '@api/responseModels/requestResult';
import { TaskListResp } from '@api/responseModels/task/taskListResponse';
import { TaskResp } from '@api/responseModels/task/taskResponse';
import { TaskModerationLogListResp } from '@api/responseModels/task/taskModerationLogResponse';

class TaskAdminGroup extends CRMAPIBase {
    async getAdminBaseTasks(
        page = 1,
        categoryId = 1,
        moderateStatus?: string[]
    ): Promise<RequestResult<TaskListResp>> {
        const result = await this.get<TaskListResp>('/admin/base-tasks', {
            page,
            category_id: categoryId,
            ...(moderateStatus?.length ? { filters: { moderate_status: moderateStatus } } : {}),
        });
        return result;
    }

    async getAdminBaseTask(id: number): Promise<RequestResult<TaskResp>> {
        const result = await this.get<TaskResp>(`/admin/base-tasks/${id}`);
        return result;
    }
    async createAdminBaseTask(params: TaskParams): Promise<RequestResult<TaskResp>> {
        const result = await this.post<TaskResp>(`/admin/base-tasks/`, params);
        return result;
    }
    async updateAdminBaseTask(params: TTask): Promise<RequestResult<TaskResp>> {
        const result = await this.put<TaskResp>(`/admin/base-tasks/${params.id}`, params);
        return result;
    }

    async deleteAdminBaseTask(params: { id: number }): Promise<RequestResult<TaskResp>> {
        const result = await this.delete<TaskResp>(`/admin/base-tasks/${params.id}`);
        return result;
    }

    async getAdminBaseTaskModerationLogs(
        id: number
    ): Promise<RequestResult<TaskModerationLogListResp>> {
        const result = await this.get<TaskModerationLogListResp>(
            `/admin/base-tasks/${id}/moderation-logs`
        );
        return result;
    }
}
export { TaskAdminGroup };
